export function getFormattedDate(value: string, period: number): string {
   let date = new Date(value);
   date = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
   switch (period) {
      case 1:
         return global.Intl.DateTimeFormat('en-us', { timeZone: 'UTC', year: 'numeric' }).format(date);
      case 2:
         let quarter;

         const month = global.Intl.DateTimeFormat('en-us', { timeZone: 'UTC', month: 'short' }).format(date);

         switch (true) {
            case month.indexOf('Mar') > -1:
               quarter = 'Q1';
               break;
            case month.indexOf('Jun') > -1:
               quarter = 'Q2';
               break;
            case month.indexOf('Sep') > -1:
               quarter = 'Q3';
               break;
            case month.indexOf('Dec') > -1:
               quarter = 'Q4';
               break;
         }

         return quarter + ' ' + global.Intl.DateTimeFormat('en-us', { timeZone: 'UTC', year: 'numeric' }).format(date);
      case 3:
         return global.Intl.DateTimeFormat('en-us', { timeZone: 'UTC', month: 'short', year: 'numeric' }).format(date);
      case 4:
         let semiAnnual;

         const semiMonth = global.Intl.DateTimeFormat('en-us', { timeZone: 'UTC', month: 'short' }).format(date);

         switch (true) {
            case semiMonth.indexOf('Jan') > -1:
               semiAnnual = 'H1';
               break;
            case semiMonth.indexOf('Jul') > -1:
               semiAnnual = 'H2';
               break;
         }

         return semiAnnual + ' ' + global.Intl.DateTimeFormat('en-us', { timeZone: 'UTC', year: 'numeric' }).format(date);
      default:
         return 'N/A';
   }
}

export function getCurrentYearMonthUnderscored(): string {
   const date = new Date();
   const year = date.getFullYear();
   const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
   return `${year}_${month}`;
}
